import { StoreReducer } from "Typings/Global";
import { DefinitionState } from "Models/Definitions/@types";
import { DefinitionsModel } from "Models/Definitions";
import utilities from "Resources/Utils";
import { parseDefinition } from "Models/Definitions/definitionParser";

const DefinitionInitialState: DefinitionState = {
    dialogFormProps: { open: false },
    list: []
}

const Definition: StoreReducer<DefinitionState> = (state = DefinitionInitialState, action) => {

    const { SHOW_DEFINITION_DIALOG_FORM, HIDE_DEFINITION_DIALOG_FORM, POST_ITEM_SUCCESS, LIST_RECEIVED, SINGLE_ITEM_RECEIVED,
        ACTIVITY_POST_SUCCESS, ITEM_DELETED, ITEM_PATCH_SUCCESS
    } = DefinitionsModel.Actions;

    switch (action.type) {
        case SHOW_DEFINITION_DIALOG_FORM: return { ...state, dialogFormProps: { ...action.data, open: true } };
        case HIDE_DEFINITION_DIALOG_FORM: return { ...state, dialogFormProps: { open: false, onCloseButtonClick: undefined } };
        case POST_ITEM_SUCCESS:
        case ITEM_PATCH_SUCCESS:
            return { ...state, list: utilities.updateItemList(state.list, parseDefinition(action.data), 'ADD') }
        case LIST_RECEIVED: return { ...state, list: (action.data || []).map(parseDefinition) }
        case SINGLE_ITEM_RECEIVED: return { ...state, definition: parseDefinition(action.data) }
        case ITEM_DELETED: {
            return {
                ...state,
                definition: state.definition?.id === action.data.id ? state.definition : undefined,
                list: utilities.updateItemList(state.list, action.additionalDispatchData.definition, 'DELETE')
            }
        }
        case ACTIVITY_POST_SUCCESS: {
            switch (action.activity) {
                case DefinitionsModel.Activities.TOGGLE_PUBLISH: {
                    return {
                        ...state,
                        definition: state.definition?.id === action.data.id ? { ...state.definition, ...parseDefinition(action.data) } : undefined,
                        list: utilities.updateItemList(state.list, parseDefinition(action.data), 'UPDATE')
                    }
                }
                default: return state;
            }
        }
        default: return state;
    }
}

export default Definition;